export default __webpack_public_path__ + "static/logo-inverse-cb798aeadfa0a40db9774ab82fedbe6b.svg";